/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetContractDto } from './GetContractDto';
import {
    GetContractDtoFromJSON,
    GetContractDtoFromJSONTyped,
    GetContractDtoToJSON,
} from './GetContractDto';
import type { GetEstimateItemDto } from './GetEstimateItemDto';
import {
    GetEstimateItemDtoFromJSON,
    GetEstimateItemDtoFromJSONTyped,
    GetEstimateItemDtoToJSON,
} from './GetEstimateItemDto';

/**
 * 
 * @export
 * @interface GetContractEstimateItemDto
 */
export interface GetContractEstimateItemDto {
    /**
     * 
     * @type {string}
     * @memberof GetContractEstimateItemDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetContractEstimateItemDto
     */
    amount: string;
    /**
     * 
     * @type {GetEstimateItemDto}
     * @memberof GetContractEstimateItemDto
     */
    estimateItem: GetEstimateItemDto;
    /**
     * 
     * @type {GetContractDto}
     * @memberof GetContractEstimateItemDto
     */
    contract: GetContractDto;
    /**
     * 
     * @type {boolean}
     * @memberof GetContractEstimateItemDto
     */
    active: boolean;
}

/**
 * Check if a given object implements the GetContractEstimateItemDto interface.
 */
export function instanceOfGetContractEstimateItemDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "amount" in value;
    isInstance = isInstance && "estimateItem" in value;
    isInstance = isInstance && "contract" in value;
    isInstance = isInstance && "active" in value;

    return isInstance;
}

export function GetContractEstimateItemDtoFromJSON(json: any): GetContractEstimateItemDto {
    return GetContractEstimateItemDtoFromJSONTyped(json, false);
}

export function GetContractEstimateItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetContractEstimateItemDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'amount': json['amount'],
        'estimateItem': GetEstimateItemDtoFromJSON(json['estimateItem']),
        'contract': GetContractDtoFromJSON(json['contract']),
        'active': json['active'],
    };
}

export function GetContractEstimateItemDtoToJSON(value?: GetContractEstimateItemDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'amount': value.amount,
        'estimateItem': GetEstimateItemDtoToJSON(value.estimateItem),
        'contract': GetContractDtoToJSON(value.contract),
        'active': value.active,
    };
}

